import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { GetTransaction } from './transaction.interface';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent {
  constructor(private http: HttpClient) {
    this.getTransaction()
  }

  TransactionItems: GetTransaction[] = []
  pageTotal: number = 0
  getTransaction(v?: any) {
    let uri: string = `transaction?page=${v?.page || 1}&limit=100`
    if (v?.value) {
      uri = `transaction?search=${v.value}&page=${v?.page || 1}&limit=100`
    }
    this.http.get('transaction').subscribe({
      next: (res: any) => {
        this.TransactionItems = res.data
        this.pageTotal = res.pageTotal
      }
    })
  }
}
